import { useEffect } from 'react';
import { unAuthAxios } from '../utils/axios';
import getUserFromToken from '../utils/getUser';
import useAuth from './useAuth';

const REFRESH_TOKEN_URL = 'token/refresh/';

const useRefreshToken = () => {
    const {auth, setAuth, logout} = useAuth();

    useEffect(() => {

        const getNewAuthToken = async () => {
            try {
                const response = await unAuthAxios.post(REFRESH_TOKEN_URL);
                const accessToken = response?.data?.access;
                
                if (!accessToken) return logout();

                const refreshToken = response?.data?.refresh;
                const user = getUserFromToken(accessToken);
        
                setAuth({accessToken, refreshToken, user});
            } catch (error) {
                // console.error(error);
                return logout();
            }
        }

        getNewAuthToken();

    }, []);
    
    return auth;
};

export default useRefreshToken;